<div class="custom-select-container" [class]="'size-' + size">
  @if (label) {
    <label class="custom-select-label">{{ label }}</label>
  }
  <select
    #selectElement
    class="custom-select"
    [disabled]="disabled"
    (change)="onSelectionChange($event)"
    >
    <option value="" disabled>{{ placeholder }}</option>
    @for (option of options; track option.value) {
      <option
        [value]="option.value"
        [disabled]="option.disabled"
        [selected]="value === option.value"
        >
        {{ option.label }}
      </option>
    }
  </select>
</div>
